"use client";

import { useEffect } from "react";
import { initMixpanel } from "./mixpanel";

export function MixpanelInit() {
  useEffect(() => {
    initMixpanel(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? "");
  }, []);

  return null;
}
